import { adminJson } from './adminJson';
import type {
  CommissionOverviewResponse,
  DashboardFilters,
  OrderStatsResponse,
  UserOverviewResponse,
  ZoneOptionList,
} from '@/types/dashboard';

/** Session filters stored server-side in dash_params (DashboardStatsJsonController). */
export type DashboardApiFilters = Partial<DashboardFilters>;

function postBody(filters: DashboardApiFilters): string {
  return JSON.stringify(filters);
}

export function fetchOrderStatistics(filters: DashboardApiFilters = {}) {
  return adminJson<OrderStatsResponse>('/admin/dashboard-stats-json/order', {
    method: 'POST',
    body: postBody(filters),
  });
}

export function fetchCommissionStatistics(filters: DashboardApiFilters = {}) {
  return adminJson<CommissionOverviewResponse>('/admin/dashboard-stats-json/commission-overview', {
    method: 'POST',
    body: postBody(filters),
  });
}

export function fetchUserStatistics(filters: DashboardApiFilters = {}) {
  return adminJson<UserOverviewResponse>('/admin/dashboard-stats-json/user-overview', {
    method: 'POST',
    body: postBody(filters),
  });
}

export function fetchDashboardZones() {
  return adminJson<ZoneOptionList>('/admin/json-compat/lookups');
}

/** Combined first-load payload (order stats + sales + rankings + user overview). */
export interface DashboardBootstrapResponse {
  data: {
    stats: OrderStatsResponse['data']['stats'];
    moduleType?: string;
    grossSale: CommissionOverviewResponse['data']['grossSale'];
    commission: CommissionOverviewResponse['data']['commission'];
    deliveryCommission: CommissionOverviewResponse['data']['deliveryCommission'];
    label: CommissionOverviewResponse['data']['label'];
    userOverview: UserOverviewResponse['data']['userOverview'];
    topSellingItems: unknown[];
    topRatedItems: unknown[];
    topRestaurants: unknown[];
    popularRestaurants: unknown[];
    topDeliverymen: unknown[];
    topCustomers: unknown[];
    params: Record<string, unknown>;
  };
}

export function fetchDashboardBootstrap(filters: DashboardApiFilters = {}) {
  return adminJson<DashboardBootstrapResponse>('/admin/dashboard-stats-json/bootstrap', {
    method: 'POST',
    body: postBody(filters),
  });
}
